import { Link } from 'react-router-dom';

import { toAbsoluteUrl } from '@/utils';

const CheckEmail = () => {
  return (
    <div className="card max-w-[440px] w-full">
      <div className="card-body p-10">
        <div className="flex justify-center py-10">
          <img
            src={toAbsoluteUrl('/media/illustrations/30.svg')}
            className="dark:hidden max-h-[130px]"
            alt=""
          />
          <img
            src={toAbsoluteUrl('/media/illustrations/30-dark.svg')}
            className="light:hidden max-h-[130px]"
            alt=""
          />
        </div>

        <h3 className="text-lg font-medium text-gray-900 text-center mb-3">E-Mail überprüfen</h3>

        <div className="text-2sm text-center text-gray-700 mb-7.5">
          Bitte klicken Sie auf den Link, den wir an Ihre E-Mail-Adresse gesendet haben
          <br />
          um Ihr Konto zu bestätigen. Vielen Dank.
        </div>

        <div className="flex justify-center mb-5">
          <Link to="/" className="btn btn-primary flex justify-center">
            Zurück zur Startseite
          </Link>
        </div>

        <div className="flex items-center justify-center gap-1">
          <span className="text-xs text-gray-700">Keine E-Mail erhalten?</span>
          <Link to="/auth/classic/login" className="text-xs font-medium link">
            Erneut senden
          </Link>
        </div>
      </div>
    </div>
  );
};

export { CheckEmail };
